import { getLoadingIndicatorsState } from '@redux/selectors/root-selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

declare global {
    interface Window {
        idwPageHasLoaded: boolean;
    }
}

export const useIsLoading = () => {
    const { activeLoadingIndicators } = useSelector(getLoadingIndicatorsState);

    useEffect(() => {
        window.idwPageHasLoaded = false;

        const onPageLoad = () => {
            if (activeLoadingIndicators.length === 0) {
                window.idwPageHasLoaded = true;
            }
        };

        // Check if the page has already loaded
        if (document.readyState === 'complete') {
            return onPageLoad();
        } else {
            window.addEventListener('load', onPageLoad);
            // Remove the event listener when component unmounts
            return () => window.removeEventListener('load', onPageLoad);
        }
    }, []);

	useEffect(() => {
        if (activeLoadingIndicators.length > 0 && window.idwPageHasLoaded) {
            window.idwPageHasLoaded = false;
        } else if (activeLoadingIndicators.length === 0 && !window.idwPageHasLoaded) {
            window.idwPageHasLoaded = true;
        }
	}, [activeLoadingIndicators]);
};